<template>
  <div class="contaniner">
    <div class="CoalModel_box_title">
      <el-page-header @back="getReturn" content="采购方详情"></el-page-header>
    </div>
    <el-divider></el-divider>
    <div>
      <el-row :gutter="10">
        <el-col :span="4">
          <div>名称：{{formItem.purchaseName}}</div>
        </el-col>
        <!-- <el-col :span="7">
          <div>地址：{{formItem.address}}</div>
        </el-col> -->
        <el-col :span="4">
          <div>收货人：{{formItem.contactName}}</div>
        </el-col>
        <el-col :span="4">
          <div>收货人手机号：{{formItem.contactPhone}}</div>
        </el-col>
        <el-col :span="8">
          <div>采购方小程序登录手机号：{{formItem.loginPhone}}</div>
        </el-col>
        <el-col :span="4">
          <div>状态：{{formItem.statusDesc}}</div>
        </el-col>
      </el-row>
    </div>

    <el-table
      :data="tableData"
      border
      width="80%">
      <el-table-column
        fixed
        prop="coalMineName"
        label="绑定煤矿">
      </el-table-column>
      <el-table-column
        prop="name"
        label="煤种">
        <template slot-scope="scope">
          <div v-if="scope.row.coalCategoryPreloadValJson">
            <div v-for="item in scope.row.coalCategoryPreloadValJson" :key="item.coalCategoryNo">
              {{item.coalCategoryName}}（{{item.preloadVal + 'T'}}）
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="totalAmount"
        label="账户资金（元）">
      </el-table-column>
      <el-table-column
        prop="dayBookingCarCount"
        label="每日车辆预约量（车）">
        <template slot-scope="scope">
          <div v-if="scope.row.coalCategoryPreloadValJson">
          <div v-for="item in scope.row.coalCategoryPreloadValJson" :key="item.coalCategoryNo">
            <span>{{item.coalCategoryName}}:{{item.dayBookingCarCount}}辆</span>
          </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="everyTimeBookingCarCount"
        label="每次预约量">
      </el-table-column>
      <!-- <el-table-column
        prop="multipleBookingFlag"
        label="是否可多次预约">
        <template slot-scope="scope">
          <span v-if="scope.row.multipleBookingFlag === 0">否</span>
          <span v-else>是</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="approvalSet"
        label="审核机制">
        <template slot-scope="scope">
          <span v-if="scope.row.approvalSet === 1">手动审核</span>
          <span v-else>自动审核</span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="statusDesc"
        label="启用状态">
      </el-table-column>
    </el-table>

    <!-- <div id="map_container"></div> -->


  </div>

</template>

<script>
import BaiduMap from '@/utils/baidu-map'
import mapStyleJson from '@/utils/custom_map_config'

let map = null
export default {
  props: ['purchaseParentNo', 'coalMineNo'],
  data() {
    return {
      activeName: 'second',
      loading: false,
      tableData: [{
        date: '1',
        name: '面煤',
        province: '2020-10-09',
        city: '普陀区',
        address: '2020-10-09'
      }, {
        date: '2',
        name: '块煤',
        province: '999',
        city: '2020-10-09',
        address: '2020-10-09'
      }],
      formItem: {}
    }
  },
  mounted() {
    const _t = this
    _t.getData()
    _t.getTableData()
    // setTimeout(function () {
    //   _t.mapInit()
    // }, 100)
  },
  methods: {
    getData() {
      const _t = this
      const form = {
        purchaseParentNo: _t.purchaseParentNo
      }
      _t.$api.purchaser.newPurchaseDetail(form).then((res) => {
        if (res.code === '0') {
          _t.formItem = res.data
        }
      })
    },
    // 获取表格数据
    getTableData() {
      const _t = this
      const form = {
        purchaseParentNo: _t.purchaseParentNo
      }
      _t.$api.purchaser.coalmineList(form).then((res) => {
        if (res.code === '0') {
          const resData = res.data.dtoList
          if (resData) {
            resData.forEach(item => {
              if (item.coalCategoryPreloadValJson) {
                item.coalCategoryPreloadValJson = JSON.parse(item.coalCategoryPreloadValJson)
              }
            })
          }
          _t.tableData = res.data.dtoList
        }
      })
    },
    // 初始化地图
    async mapInit() {
      // await BaiduMap.init();
      map = new BMapGL.Map('map_container', {
        enableMapClick: false
      })
      map.enableScrollWheelZoom()
      map.setMapStyleV2({
        styleJson: mapStyleJson
      })

      if (this.formItem.lng && this.formItem.lat) {
        const pp = {
          lng: this.formItem.lng,
          lat: this.formItem.lat
        }
        map.centerAndZoom(pp, 15)
        map.addOverlay(new BMapGL.Marker(pp))
      }
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    getReturn() {
      this.$emit('backFun', false)
    },
    detailLink() {
      this.$emit('checkDetail')
    }
  }

}
</script>

<style scoped>
  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    margin-right: 30px;
  }

  .el-table {
    width: 100%;

  }

  .contaniner {
    padding-bottom: 100px;
  }

  #map_container {
    width: 100%;
    height: 400px;
    margin-top: 50px;
  }
</style>
